import { memo } from "react";

import { Typography } from "neetoui";

const PercentageBar = ({ value }) => (
  <>
    {value !== 0 && (
      <div
        className="neeto-ui-bg-gray-300 neeto-ui-rounded-full h-2"
        style={{ width: `${value}%` }}
      />
    )}
    <Typography style="body3">{value ? `${value}%` : 0}</Typography>
  </>
);

export default memo(PercentageBar);
